import React from "react";

const REASONS = [
  {
    n: "01",
    title: "Engineered for perfect neck & spine support",
    body:
      "47 pinch-tuck chambers adapt to your sleeping position — side, back or stomach — keeping your cervical spine in perfect neutral alignment all night long. The kind of support physiotherapists recommend.",
    sticker: "spine-saver",
    stickerCls: "sticker-lavender",
    img: "/assets/ugc_woman_1.png",
  },
  {
    n: "02",
    title: "100% Hungarian goose down · 800+ fill power",
    body:
      "The world's highest-grade down, hand-collected from RDS-certified European farms. Three times more lift than synthetic, eight times softer than feather — and it stays plump for 5+ years.",
    sticker: "cloud-soft",
    stickerCls: "sticker-lime",
    img: "/assets/Almohada_2_Mejorada.png",
  },
  {
    n: "03",
    title: "14 hours of slow, master-artisan craft",
    body:
      "Each pillow is hand-stitched in our Dubai atelier across 14 hours. Hand-loomed Egyptian cotton, hand-collected down, triple-stitched seams — the same construction reserved for 7-star hotel suites. Only 200 made per week.",
    sticker: "200 / week",
    stickerCls: "sticker-pink",
    img: "/assets/packaging_1.png",
  },
];

export default function ThreeReasons() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="text-center max-w-3xl mx-auto">
          <span className="section-pill">🏆 The 3 reasons</span>
          <h2 className="mt-5 text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
            Three reasons it&apos;s worth
            <br />
            every single dollar.
          </h2>
        </div>

        <div className="mt-14 space-y-5 max-w-5xl mx-auto">
          {REASONS.map((r, i) => (
            <div
              key={r.n}
              className={`grid md:grid-cols-[280px_1fr] gap-6 md:gap-10 items-center bg-white rounded-[28px] border border-black/5 p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow ${
                i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
              }`}
            >
              <div className="relative">
                <div className="aspect-[4/5] md:aspect-square overflow-hidden rounded-2xl bg-[#faf8f4]">
                  <img
                    src={r.img}
                    alt={r.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <span
                  className={`sticker ${r.stickerCls} absolute -top-3 -right-3 text-[11px]`}
                >
                  {r.sticker}
                </span>
              </div>
              <div>
                <div className="text-[40px] md:text-[56px] font-black leading-none text-[#c9a8ff]/70 select-none">
                  {r.n}
                </div>
                <h3 className="mt-3 text-[20px] md:text-[24px] font-black text-[#0e0e10] leading-tight">
                  {r.title}
                </h3>
                <p className="mt-3 text-[#5a5a60] text-[14px] md:text-[15px] leading-relaxed">
                  {r.body}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo("shop")}
            className="pill-btn px-8 py-4 text-[15px]"
            data-testid="three-reasons-cta"
          >
            Shop Now — from $147 →
          </button>
        </div>
      </div>
    </section>
  );
}
